import { QueueRule } from '../../../rules/models/queueRule';
import { Url } from '../../../utils/codecUtils';
import {
  suggestTriggerConditionPayloadSchema,
  suggestTriggerConditionResponseSchema,
} from './suggestTriggerCondition.schema';

export type SuggestTriggerConditionPayload = {
  userQuery: string;
  schemaRule: Partial<QueueRule>;
  queue: Url;
};

export type SuggestTriggerConditionResult = {
  triggerCondition?: string;
  triggerConditionSummary?: string;
};

export type SuggestTriggerConditionResponse = {
  results: Array<SuggestTriggerConditionResult>;
};

export const suggestTriggerCondition = (
  payload: SuggestTriggerConditionPayload
) =>
  ({
    endpoint: `internal/rules/suggest_trigger_condition`,
    method: 'POST',
    responseSchema: suggestTriggerConditionResponseSchema,
    payloadSchema: suggestTriggerConditionPayloadSchema,
    payload,
  }) as const;
